import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useInView } from '@/hooks/useInView';

const partnerStores = [
  {
    name: '博客來',
    url: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=daiho43',
    icon: 'ri-shopping-bag-3-line',
    domain: 'books.com.tw',
    category: '實體與線上書店',
  },
  {
    name: '誠品',
    url: 'https://www.eslite.com/search?keyword=山頂視角文化事業有限公司',
    icon: 'ri-store-2-line',
    domain: 'eslite.com',
    category: '實體與線上書店',
  },
  {
    name: '金石堂',
    url: 'https://www.kingstone.com.tw/bookpublish/publist/62615/',
    icon: 'ri-book-open-line',
    domain: 'kingstone.com.tw',
    category: '實體與線上書店',
  },
  {
    name: '三民',
    url: 'https://www.sanmin.com.tw/search?pu=山頂視角',
    icon: 'ri-book-2-line',
    domain: 'sanmin.com.tw',
    category: '實體與線上書店',
  },
  {
    name: 'momo',
    url: 'https://www.momoshop.com.tw/search/山頂視角?brand=山頂視角',
    icon: 'ri-shopping-cart-2-line',
    domain: 'momoshop.com.tw',
    category: '綜合電商',
  },
  {
    name: '蝦皮',
    url: 'https://shopee.tw/sonbook',
    icon: 'ri-store-3-line',
    domain: 'shopee.tw',
    category: '綜合電商',
  },
  {
    name: 'TAAZE 讀冊',
    url: 'https://www.taaze.tw/rwd_searchResult.html?keyType%5B%5D=3&keyword%5B%5D=山頂視角',
    icon: 'ri-book-read-line',
    domain: 'taaze.tw',
    category: '實體與線上書店',
  },
  {
    name: 'Amazon Kindle',
    url: 'https://www.amazon.com/s?k=山頂視角',
    icon: 'ri-amazon-line',
    domain: 'amazon.com',
    category: '電子書平台',
  },
  {
    name: '樂天 Kobo',
    url: 'https://www.kobo.com/tw/zh',
    icon: 'ri-tablet-line',
    domain: 'kobo.com',
    category: '電子書平台',
  },
  {
    name: 'Pubu',
    url: 'https://www.pubu.com.tw/store/4193937',
    icon: 'ri-smartphone-line',
    domain: 'pubu.com.tw',
    category: '電子書平台',
  },
  {
    name: 'OverDrive',
    url: 'https://www.overdrive.com/publishers/山頂視角',
    icon: 'ri-globe-line',
    domain: 'overdrive.com',
    category: '電子書平台',
  },
  {
    name: 'MyBook',
    url: 'https://mybook.mobi/mybook/zh-TW/#',
    icon: 'ri-phone-line',
    domain: 'mybook.mobi',
    category: '電子書平台',
  },
  {
    name: 'Hami Book',
    url: 'https://www.hamibook.com.tw/Search/finish?keyword=山頂視角',
    icon: 'ri-bookmark-line',
    domain: 'hamibook.com.tw',
    category: '電子書平台',
  },
];

const categories = ['實體與線上書店', '綜合電商', '電子書平台'];

export default function Stores() {
  const { ref: ref1, inView: inView1 } = useInView();
  const { ref: ref2, inView: inView2 } = useInView();

  const animClass = (inView: boolean) =>
    `transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`;

  return (
    <>
      <Navbar />
      <main className="pt-0">
        <section
          ref={ref1}
          className="relative w-full min-h-[60svh] flex flex-col justify-center items-center overflow-hidden"
        >
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Majestic%20mountain%20landscape%20with%20warm%20afternoon%20light%20across%20textured%20ridges%20and%20deep%20valleys%2C%20rich%20natural%20earth%20tones%20of%20green%20pine%20covered%20slopes%20and%20ochre%20rocky%20peaks%2C%20clear%20sky%20with%20soft%20golden%20clouds%2C%20expansive%20panoramic%20view%20from%20high%20elevation%2C%20tranquil%20and%20grounded%20atmosphere%2C%20fine%20art%20nature%20photography%20with%20excellent%20depth%20and%20detail%2C%20organic%20textures%20throughout%2C%20no%20snow%2C%20no%20water%2C%20no%20buildings%2C%20no%20people&width=1920&height=1080&seq=stores-hero-001&orientation=landscape"
              alt="合作購書通路 — 山脈午後全景"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-primary-950/65 via-primary-950/35 to-primary-950/55"></div>

          <div className="relative z-10 w-full px-6 md:px-10 pt-20 md:pt-24 pb-12 md:pb-16">
          <div className={`max-w-3xl mx-auto w-full text-center ${animClass(inView1)}`}>
            <p className="text-xs font-label tracking-widest text-white/70 mb-3 uppercase text-shadow-section">Stores</p>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-4 text-shadow-section">
              合作購書通路
            </h1>
            <p className="text-sm md:text-base text-white/75 max-w-xl mx-auto leading-relaxed text-shadow-section">
              透過以下合作通路查找山頂視角出版書籍，各平台上架情況可能不同。
            </p>
          </div>
          </div>
        </section>

        <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
          <div className="max-w-6xl mx-auto w-full">

            {categories.map((cat) => (
              <div key={cat} className="mb-12 last:mb-0">
                <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-800 mb-5 text-center">
                  {cat}
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                  {partnerStores
                    .filter((s) => s.category === cat)
                    .map((store) => (
                      <a
                        key={store.name}
                        href={store.url}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="group flex items-center gap-4 px-5 py-4 bg-background-100 hover:bg-background-200 rounded-xl border border-background-300 transition-all duration-300"
                      >
                        <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100">
                          <i className={`${store.icon} text-accent-700`}></i>
                        </div>
                        <div className="text-left flex-1 min-w-0">
                          <p className="font-label font-medium text-sm text-foreground-950 whitespace-nowrap">{store.name}</p>
                          <p className="text-xs text-foreground-500 truncate">{store.domain}</p>
                        </div>
                        <i className="ri-external-link-line text-foreground-400 group-hover:text-foreground-700 transition-colors flex-shrink-0"></i>
                      </a>
                    ))}
                </div>
              </div>
            ))}

            <div className="mt-14 pt-10 border-t border-background-200/70 flex justify-center">
              <a
                href="https://catalog.sonbook.net/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="group flex items-center gap-3 px-6 py-4 bg-background-100 hover:bg-background-200 rounded-xl border border-background-200 transition-all duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-200">
                  <i className="ri-database-2-line text-secondary-700"></i>
                </div>
                <div className="text-left">
                  <p className="font-label font-medium text-sm text-foreground-950 whitespace-nowrap">前往崧博出版書籍資料庫</p>
                  <p className="text-xs text-foreground-500">catalog.sonbook.net</p>
                </div>
                <i className="ri-external-link-line text-foreground-400 group-hover:text-foreground-700 transition-colors ml-2"></i>
              </a>
            </div>
          </div>
        </section>

        <section
          ref={ref2}
          className="min-h-[50svh] flex items-center px-6 md:px-10 py-16 md:py-20 bg-accent-50"
        >
          <div className={`max-w-3xl mx-auto w-full text-center ${animClass(inView2)}`}>
            <div className="w-12 h-12 mx-auto mb-5 flex items-center justify-center rounded-full bg-background-100">
              <i className="ri-information-line text-accent-700 text-lg"></i>
            </div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
              購書提醒
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              各平台上架時間、庫存與售價可能不同。正式書目以崧博出版書籍資料庫為準。
            </p>
            <a
              href="https://sonbook.net/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 bg-secondary-500 text-white font-label font-medium text-sm rounded-full hover:bg-secondary-600 transition-all duration-300 whitespace-nowrap"
            >
              前往崧博出版
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}